import { render, staticRenderFns } from "./create-sub-task.vue?vue&type=template&id=6480adaa&scoped=true&"
import script from "./create-sub-task.vue?vue&type=script&lang=js&"
export * from "./create-sub-task.vue?vue&type=script&lang=js&"
import style0 from "./create-sub-task.vue?vue&type=style&index=0&id=6480adaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6480adaa",
  null
  
)

export default component.exports